import React, { Component } from 'react'
import Form from '../../old_Components/ATS/AddNewCandidate'
import { isATSEnabled, AddNewCandidate, genderDropDown } from '../../action/auth';
import constant from '../../constant';
import swal from 'sweetalert';
import { courseType, education, gradingSystem } from '../../action/education';
import { qualificationList } from '../../action/jobs';
export default class Onboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ATS_ENABLED: 0,
            showLoader: false,
            EDUCATION: [],
            GENDER_OPTIONS: [],
            GRADING_SYSTEM_OPTIONS: [],
            COURSE_TYPE: []
        }


    }
    componentDidMount() {
        document.title = constant.title.ATS_CANDIDATE_ONBOARD
        isATSEnabled().then(res => {
            if (res.status) {
                this.setState({ ATS_ENABLED: res.result })
                if (res.result == 0) {
                    this.props.history.push(constant.component.Dashboard.url)
                }
            }
        })


        qualificationList().then(res => {
            if (res.status) {
                this.setState({ EDUCATION: res.result })

            }
        })

        courseType().then(res => {
            if (res.status) {
                this.setState({ COURSE_TYPE: res.result })

            }
        })

        gradingSystem().then(res => {
            if (res.status) {
                this.setState({ GRADING_SYSTEM_OPTIONS: res.result })

            }
        })
        genderDropDown().then(res => {
            if (res.status) {
                this.setState({ GENDER_OPTIONS: res.result })
            }
        })


    }
    onSubmit = (formData) => {
        this.setState({ showLoader: true })
        AddNewCandidate(formData).then(res => {
            this.setState({ showLoader: false })
            if (res.status) {
                swal({
                    icon: "success",
                    text: res.result.message,
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false,
                });
                setTimeout(window.location.reload(), 2000)
            }
            else {
                swal({
                    icon: "error",
                    text: res.error,
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false,
                });
            }
        })
    }
    render() {
        const { showLoader, COURSE_TYPE, EDUCATION, GRADING_SYSTEM_OPTIONS, GENDER_OPTIONS } = this.state
        return (
            <React.Fragment>
                <Form
                    EDUCATION_OPTIONS={EDUCATION}
                    COURSE_TYPE_OPTIONS={COURSE_TYPE}
                    GRADING_SYSTEM_OPTIONS={GRADING_SYSTEM_OPTIONS}
                    GENDER_OPTIONS={GENDER_OPTIONS}
                    showLoader={showLoader}
                    onSubmit={(formData) => { this.onSubmit(formData) }}
                    
                />
            </React.Fragment>
        )
    }
}
